/**
 * Field-name catalogues per import type. Centralised so updates to the
 * recognised CSV columns don't require touching JSX.
 */
export const PATIENT_FIELDS = {
  required: ['first_name', 'last_name', 'date_of_birth', 'medicaid_id', 'payer_type'],
  recommended: [
    'gender', 'phone', 'address', 'city', 'state', 'zip_code',
    'county', 'payer_program', 'procedure_code',
  ],
  optional: [
    'middle_name', 'suffix', 'ssn', 'medicare_id', 'address_line2',
    'managed_care_plan', 'place_of_service', 'relationship_to_subscriber',
    'is_newborn', 'payer_effective_start', 'payer_effective_end',
    'physician_npi', 'physician_name', 'prior_auth_number',
    'primary_icd10_code', 'secondary_icd10_code',
    'secondary_payer_type', 'secondary_insurance_id',
    'emergency_contact_name', 'emergency_contact_phone', 'notes',
  ],
};

export const EMPLOYEE_FIELDS = {
  required: ['first_name', 'last_name', 'employee_id', 'hire_date', 'job_title'],
  recommended: ['ssn_full', 'phone', 'email', 'date_of_birth', 'npi', 'employee_medicaid_id'],
  optional: [
    'ssn_last_four', 'address', 'city', 'state', 'zip_code',
    'hourly_rate', 'certification_type', 'certification_expiry',
    'sandata_employee_id', 'notes',
  ],
};

export const fieldsForType = (importType) =>
  importType === 'patient' ? PATIENT_FIELDS : EMPLOYEE_FIELDS;
